import React from 'react'

import CommonMainFormCheckBox from '../../../shared/components/MainFormCheckBox'

const MainFormCheckBox = props => {
  const labelStyles = {color: '#1A1A1A'}
  return <CommonMainFormCheckBox {...props} labelStyles={labelStyles} />
}

export default MainFormCheckBox
